import { parseOneAddress } from "email-addresses";

/**
 * Returns true if the string contains a valid email address.
 */
export const isValidEmail = (str: string) => {
	if (typeof str !== "string") {
		return false;
	}

	const email = parseOneAddress(str);
	return email !== null;
};
